module.exports = __webpack_public_path__ + "img/product_banner@2x.3b97cbab.png";